<template>
    <v-card>
        <v-form
            ref="subscribeFormLinkGenerator"
            v-model="isValid"
        >
            <v-card-text>
                <v-container
                    class="pb-0"
                    fluid
                >
                    <v-row class="pb-0">
                        <v-col cols="12">
                            <v-select
                                :items="representatives"
                                :rules="[requiredRule]"
                                @input="representativeChange"
                                item-text="value"
                                item-value="key"
                                label="Representative"
                                v-model="representativeid"
                            ></v-select>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :items="representativeProducts"
                                :rules="[requiredRule]"
                                item-text="value"
                                item-value="key"
                                label="Representative Product"
                                v-model="productcode"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :rules="[requiredRule,lengthRule(50)]"
                                label="Cell"
                                v-model="cell"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-select
                                :items="reps"
                                :rules="[]"
                                item-text="value"
                                item-value="key"
                                label="Signed By"
                                v-model="signedbyuserid"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :rules="[lengthRule(50)]"
                                label="Card Number"
                                v-model="cardnumber"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="12">
                            <v-divider></v-divider>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                id="formlinkfield"
                                label="Form Link"
                                readonly
                                v-model="formlink"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="4">
                            <v-btn
                                :disabled="!formlink"
                                @click="copylink"
                                class="text-none"
                                color="secondary darken-1"
                            >Copy</v-btn>
                        </v-col>
                        <v-col cols="4">
                            <v-btn
                                :disabled="!formlink"
                                @click="gotolink"
                                class="text-none"
                                color="secondary darken-1"
                            >Go To</v-btn>
                        </v-col>
                    </v-row>
                    <v-row
                        align="end"
                        class="pt-0"
                        justify="end"
                        no-gutters
                    >
                        <!--<v-btn
                            :disabled="isLoading && !isDeleting"
                            :loading="isDeleting"
                            @click="deleteEntity"
                            class="text-none"
                            color="warning darken-1"
                            text
                            v-show="company.id > 0"
                        >Delete</v-btn>-->
                        <v-btn
                            :disabled="isLoading"
                            @click="closeForm"
                            class="text-none"
                            color="secondary darken-1"
                            text
                        >Close</v-btn>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-form>
        <v-snackbar
            :color="notifyColor"
            :timeout="15000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
    </v-card>
</template>

<script>
export default {
    props: {},
    mounted: async function() {
        this.reps = await this.$store.dispatch("users/getAccisureReps");
        this.representatives = await this.$store.dispatch(
            "representatives/getlist"
        );
        //this.representativeProducts = await this.$store.dispatch("representativeProducts/getrepresentativeproductscodes",representativeid);

        //get representatives
        //get signedbyusers
    },
    components: {
        //
    },
    data() {
        return {
            baselink: "http://eraf.accicare.co.za/accisureform",
            reps: [],
            representatives: [],
            representativeProducts: [],
            isValid: null,
            cell: "",
            cardnumber: "",
            signedbyuserid: null,
            representativeid: null,
            productcode: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters"
        };
    },
    computed: {
        formlink() {
            //https://eraf.accicare.co.za/accisureform?repcode=1&productcode=1&cell=0123456789
            if (this.representativeid && this.productcode && this.cell) {
                return (
                    this.baselink +
                    "?repcode=" +
                    encodeURIComponent(this.representativeid) +
                    "&productcode=" +
                    encodeURIComponent(this.productcode) +
                    "&cell=" +
                    encodeURIComponent(this.cell) +
                    (this.cardnumber
                        ? "&cardnumber=" + encodeURIComponent(this.cardnumber)
                        : "") +
                    (this.signedbyuserid
                        ? "&signedbyuserid=" +
                          encodeURIComponent(this.signedbyuserid)
                        : "")
                );
            } else {
                return "";
            }
        }
    },
    methods: {
        representativeChange() {
            this.$refs.subscribeFormLinkGenerator.validate();
            this.productcode = null;
            this.representativeProducts = [];
            if (this.representativeid > 0)
                this.$store
                    .dispatch(
                        "representativeProducts/getrepresentativeproductscodes",
                        this.representativeid
                    )
                    .then(data => {
                        this.representativeProducts = data;
                    });
        },
        copylink() {
            var copyText = document.getElementById("formlinkfield");

            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text inside the text field */
            document.execCommand("copy");
        },
        gotolink() {
            window.open(this.formlink, "_blank");
        },
        //emitters      ------------------------------------------------------------
        emitCloseForm() {
            this.$emit("close");
            this.cell = "";
            this.cardnumber = "";
            this.signedbyuserid = null;
            this.representativeid = null;
            this.productcode = null;
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.$refs.subscribeFormLinkGenerator.validate();
        }
    }
};
</script>

<style lang="stylus" scoped></style>